<p-toast></p-toast>

<!-- Opened in place from openAgentIntake() -- not routerLink="/agent-intake",
     which would navigate away from wherever this dashboard is embedded
     (HomeComponent's accordion) just to reach DocumentsComponent's route.
     That route stays as the Teams Claim deep link's own entry point; this
     is a second, in-app way to reach the same dialog without leaving the
     page. -->
<app-create-new-document [agentRequestId]="agentIntakeRequestId" [display]="displayAgentIntake"
                          (displayChange)="onAgentIntakeDisplayChange($event)" (done)="onAgentIntakeDone()"
                          *ngIf="displayAgentIntake">
</app-create-new-document>

<p-panel header="Agent — панель стану черги">
  <div class="fluid formgrid grid">
    <div class="field col-2 xl:col-2 sm:col-6">
      <label for="AD1" class="do-not-wrap-text">Початок періоду</label>
      <p-calendar id="AD1" dateFormat="dd.mm.yy" [(ngModel)]="dateFrom" (onSelect)="reload()"
                  showButtonBar="true" selectOtherMonths="true" firstDayOfWeek="1"></p-calendar>
    </div>
    <div class="field col-2 xl:col-2 sm:col-6">
      <label for="AD2" class="do-not-wrap-text">Кінець періоду</label>
      <p-calendar id="AD2" dateFormat="dd.mm.yy" [(ngModel)]="dateTo" [minDate]="dateFrom" (onSelect)="reload()"
                  showButtonBar="true" selectOtherMonths="true" firstDayOfWeek="1"></p-calendar>
    </div>
    <div class="field col-4 xl:col-4 sm:col-12">
      <label class="do-not-wrap-text">Гранулярність тренду</label>
      <p-selectButton [options]="granularityOptions" [(ngModel)]="selectedGranularity" optionLabel="label" optionValue="value"
                       (onChange)="onGranularityChange()"></p-selectButton>
    </div>
  </div>

  <div *ngIf="loaded; else summaryLoading">
    <div class="grid">
      <div class="col-12 md:col-2">
        <p-card styleClass="text-center">
          <div class="text-500">Всього звернень</div>
          <div class="text-3xl font-bold">{{summary.totalIncoming}}</div>
        </p-card>
      </div>
      <div class="col-12 md:col-2">
        <p-card styleClass="text-center">
          <div class="text-500">Обслуговано</div>
          <div class="text-3xl font-bold" style="color:#277622">{{summary.served}}</div>
        </p-card>
      </div>
      <div class="col-12 md:col-2">
        <p-card styleClass="text-center">
          <div class="text-500">Відхилено</div>
          <div class="text-3xl font-bold" style="color:#B08D00">{{summary.ignored}}</div>
        </p-card>
      </div>
      <div class="col-12 md:col-2">
        <p-card styleClass="text-center">
          <div class="text-500">Пропущено</div>
          <div class="text-3xl font-bold" style="color:#BB1010">{{summary.missed}}</div>
        </p-card>
      </div>
      <div class="col-12 md:col-2">
        <p-card styleClass="text-center">
          <div class="text-500">Спам</div>
          <div class="text-3xl font-bold text-500">{{summary.spam}}</div>
        </p-card>
      </div>
      <div class="col-12 md:col-2">
        <p-card styleClass="text-center">
          <div class="text-500">В роботі</div>
          <div class="text-3xl font-bold">{{summary.inFlight}}</div>
        </p-card>
      </div>
    </div>

    <div class="grid mt-2">
      <div class="col-12">
        <p-chart type="bar" [data]="trendChartData" [options]="trendChartOptions" width="100%" height="20rem"></p-chart>
      </div>
    </div>

    <div class="grid mt-2" *ngIf="sla">
      <div class="col-12 md:col-3">
        <p-card>
          <div class="text-500">Час до взяття в роботу (медіана / максимум)</div>
          <div class="text-xl">{{formatMinutes(sla.medianTimeToClaimMinutes)}} / {{formatMinutes(sla.maxTimeToClaimMinutes)}}</div>
        </p-card>
      </div>
      <div class="col-12 md:col-3">
        <p-card>
          <div class="text-500">Час до завершення (медіана / максимум)</div>
          <div class="text-xl">{{formatMinutes(sla.medianTimeToResolveMinutes)}} / {{formatMinutes(sla.maxTimeToResolveMinutes)}}</div>
        </p-card>
      </div>
      <div class="col-12 md:col-3">
        <p-card>
          <div class="text-500">Ескалацій за період</div>
          <div class="text-xl">{{sla.escalationCount}}</div>
        </p-card>
      </div>
    </div>
  </div>
  <ng-template #summaryLoading>
    <p>Дані завантажуються...</p>
  </ng-template>
</p-panel>

<p-panel header="Останні звернення" styleClass="mt-3">
  <!-- Merged control row: filters and actions on left, reload button on right.
       Positioned outside the *ngIf gate so "Оновити" stays reachable while loading.
       Every action control is always rendered and only enabled/disabled by the
       selected row's state -- deliberately not hidden with *ngIf. Hiding would
       make this bar change shape as selection moves, causing the same layout
       jumpiness that moving actions out of rows was meant to remove. Visibility
       of all available actions is what the per-row column gave for free. -->
  <div class="flex align-items-center justify-content-between gap-2 mb-3 flex-wrap">
    <div class="flex align-items-center gap-2 flex-wrap">
      <label for="AD3" class="do-not-wrap-text">Кількість</label>
      <p-dropdown id="AD3" [options]="recentLimitOptions" [(ngModel)]="recentLimit" (onChange)="loadRecent()"></p-dropdown>

      <button pButton pRipple type="button" label="Відкрити" icon="pi pi-external-link" class="p-button-sm p-button-outlined"
              [disabled]="!canOpenSelected" (click)="openAgentIntake(selectedRecent)"
              pTooltip="Відкрити у панелі AI Assist" tooltipPosition="top"></button>

      <button pButton pRipple type="button" label="Взяти в роботу" icon="pi pi-check" class="p-button-sm p-button-success"
              [disabled]="!canActOnSelected" (click)="onClaim(selectedRecent)"
              pTooltip="Взяти звернення в роботу" tooltipPosition="top"></button>

      <!-- appendTo="body" carried over from the resizable-columns work: it was added
           when this dropdown lived inside a table cell that clipped its panel. The
           cell is gone, but rendering the panel at body level is still the safer
           default in a wrapping flex bar, and it costs nothing. -->
      <p-dropdown [options]="ignoreReasons" optionLabel="title" optionValue="value"
                  placeholder="Причина відхилення..." [(ngModel)]="selectedIgnoreReason"
                  [disabled]="!canActOnSelected" styleClass="p-inputtext-sm" appendTo="body"></p-dropdown>
      <button pButton pRipple type="button" label="Відхилити" icon="pi pi-times" class="p-button-sm p-button-warning"
              [disabled]="!canIgnoreSelected" (click)="onIgnore(selectedRecent)"
              pTooltip="Відхилити -- потрібно вибрати причину" tooltipPosition="top"></button>

      <button pButton pRipple type="button" label="Спам" icon="pi pi-ban" class="p-button-sm p-button-danger"
              [disabled]="!canActOnSelected" (click)="onSpam(selectedRecent)"
              pTooltip="Позначити як спам" tooltipPosition="top"></button>

      <span *ngIf="!selectedRecent" class="text-500 ml-2">Виберіть рядок</span>
    </div>
    <p-button icon="pi pi-refresh" label="Оновити" styleClass="p-button-success" (onClick)="loadRecent()"
              pTooltip="Оновити список звернень" tooltipPosition="top"></p-button>
  </div>

  <div *ngIf="recentLoaded; else recentLoading">
    <p-table #ptableRecent [value]="recent" [rowHover]="true"
             selectionMode="single" [(selection)]="selectedRecent"
             [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10,20,50,100]"
             [showCurrentPageReport]="true" currentPageReportTemplate="Показано от {first} до {last} из {totalRecords} звернень"
             sortMode="single" dataKey="id" [resizableColumns]="true"
             styleClass="p-datatable p-datatable-gridlines p-datatable-striped">
      <ng-template pTemplate="header">
        <tr>
          <!-- AgentRequests.id. It is how one person names a request to another, and what
               webyto-agent's re-resolve tool takes as its argument, but it used to appear
               nowhere readable -- not here, not on the Teams card (now fixed there too). -->
          <th pResizableColumn pSortableColumn="id" style="width: 5rem"># <p-sortIcon field="id"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="receivedAt">Отримано <p-sortIcon field="receivedAt"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="senderEmail">Відправник <p-sortIcon field="senderEmail"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="customerName">Клієнт <p-sortIcon field="customerName"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="bucket">Статус <p-sortIcon field="bucket"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="claimedByName">Взяв в роботу <p-sortIcon field="claimedByName"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="outcome">Результат <p-sortIcon field="outcome"></p-sortIcon></th>
          <th pResizableColumn>Документ</th>
        </tr>
        <tr>
          <th><input pInputText type="text" [(ngModel)]="cfRecent['id']" (input)="ptableRecent.filter($event.target.value, 'id', 'contains')" placeholder="Пошук" class="p-column-filter"></th>
          <th><input pInputText type="text" [(ngModel)]="cfRecent['receivedAt']" (input)="ptableRecent.filter($event.target.value, 'receivedAt', 'contains')" placeholder="Пошук" class="p-column-filter"></th>
          <th><input pInputText type="text" [(ngModel)]="cfRecent['senderEmail']" (input)="ptableRecent.filter($event.target.value, 'senderEmail', 'contains')" placeholder="Пошук" class="p-column-filter"></th>
          <th><input pInputText type="text" [(ngModel)]="cfRecent['customerName']" (input)="ptableRecent.filter($event.target.value, 'customerName', 'contains')" placeholder="Пошук" class="p-column-filter"></th>
          <th><input pInputText type="text" [(ngModel)]="cfRecent['bucket']" (input)="ptableRecent.filter($event.target.value, 'bucket', 'contains')" placeholder="Пошук" class="p-column-filter"></th>
          <th><input pInputText type="text" [(ngModel)]="cfRecent['claimedByName']" (input)="ptableRecent.filter($event.target.value, 'claimedByName', 'contains')" placeholder="Пошук" class="p-column-filter"></th>
          <th><input pInputText type="text" [(ngModel)]="cfRecent['outcome']" (input)="ptableRecent.filter($event.target.value, 'outcome', 'contains')" placeholder="Пошук" class="p-column-filter"></th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr [pSelectableRow]="item">
          <td class="font-bold">{{item.id}}</td>
          <td>{{item.receivedAt | date:'dd.MM.yyyy HH:mm'}}</td>
          <td>{{item.senderEmail}}</td>
          <td>{{item.customerName || '—'}}</td>
          <td>
            <p-tag [severity]="item.bucket === 'served' ? 'success' : item.bucket === 'missed' ? 'danger' : item.bucket === 'ignored' ? 'warning' : item.bucket === 'spam' ? 'secondary' : 'info'"
                   [value]="item.bucket"></p-tag>
          </td>
          <td>{{item.claimedByName || '—'}}</td>
          <td>{{item.outcome || '—'}}</td>
          <td>
            <a *ngIf="item.document" [routerLink]="['/edit-document', item.document.docType, item.document.docId]">
              {{item.document.docNumber || item.document.docId}}
            </a>
            <span *ngIf="!item.document">—</span>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr><td colspan="8">Немає звернень</td></tr>
      </ng-template>
    </p-table>
  </div>
  <ng-template #recentLoading>
    <p>Дані завантажуються...</p>
  </ng-template>
</p-panel>
